import React, { PropsWithChildren, ReactNode } from "react";

interface FieldContainerProps {
  isHeader?: boolean;
}

export const FieldContainer: React.FC<PropsWithChildren<FieldContainerProps>> = ({children, isHeader}) => {
    return (
        <div className={isHeader ?  "guardian-field-header-container" : "guardian-field-container"}>
            {children}
        </div>
    );
}